import { PerformInspectionWorkflow } from "@/components/inspection/perform-workflow";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/inspection/$licenseId/perform")({
  component: PerformInspectionWorkflow,
});
